var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container d-flex flex-grow-1 justify-content-center"},[_c('div',[_c('br'),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data)}}),_c('br'),_c('br'),_c('br'),_c('br')])])
}
var staticRenderFns = []

export { render, staticRenderFns }